export const RATE_CARD_PRICE_MAX_FRACTION_DIGITS = 8
